export default __webpack_public_path__ + "static/media/p1000-tip-box-open.fb6e8155.svg";